import * as React from 'react';
import b_ from 'b_';
import { useTranslation } from 'react-i18next';
import SingleTooltip from 'components/SingleTooltip';
import { ArchiveTooltip } from './components/ArchiveTooltip';
import { CancelTooltip } from './components/CancelTooltip';
import { OrderActionsFragment } from './__generated__/OrderActionsFragment';

import './index.scss';

import * as iconClose from './static/img/close.svg';
import * as iconArchive from './static/img/archive.svg';
import { OrderType } from 'components/Order/types';

type Order = OrderActionsFragment;

interface Props {
  order: Order;
}

const b = b_.with('order-card-action');

export const Actions: React.FC<Props> = ({ order }) => {
  const { t } = useTranslation();

  switch (order.__typename) {
    case OrderType.Stock:
      if (order.canArchived) {
        return (
          <SingleTooltip
            placement="topRight"
            content={({ close }) => (
              <ArchiveTooltip productType="stocks" orderId={order.id} close={close} />
            )}
          >
            <img
              className={b('archive-icon')}
              src={iconArchive}
              alt=""
              title={t('Archive')}
              data-testid="archive-btn"
            />
          </SingleTooltip>
        );
      }
      return null;
    case OrderType.Idea:
      if (order.isCancelable && order.product != null) {
        return (
          <SingleTooltip
            placement="topRight"
            content={({ close }) => (
              <CancelTooltip
                orderId={order.id}
                amount={order.requestAmount}
                ideaType={order.product!.ideaType}
                ideaId={order.product!.id}
                close={close}
              />
            )}
          >
            <img
              className={b('close-icon')}
              src={iconClose}
              alt="X"
              title={t('Cancel')}
              data-testid="cancel-btn"
            />
          </SingleTooltip>
        );
      }

      if (order.canArchive && order.product != null) {
        return (
          <SingleTooltip
            placement="topRight"
            content={({ close }) => (
              <ArchiveTooltip
                productType="idea"
                ideaType={order.product!.ideaType}
                orderId={order.id}
                close={close}
              />
            )}
          >
            <img
              className={b('archive-icon')}
              src={iconArchive}
              alt=""
              title={t('Archive')}
              data-testid="archive-btn"
            />
          </SingleTooltip>
        );
      }
  }

  return null;
};
